import classNames from "classnames";
import { useState } from "react";
import { MiniButton } from "./conditions-buttons";
import { ConditionsFieldSet } from "./conditions-field-set";
import { ConditionsGroup } from "./conditions-group";

export function ConditionsCondition({
  data,
  condition,
  idx,
  path,
  update,
  errors,
  defaultSuggestion,
  editing,
}) {
  const [viewSource, setViewSource] = useState(false);
  const [mightDelete, setMightDelete] = useState(false);

  const definition = data.definitions[condition.type];
  const fieldSet = definition && data.fields[definition.type];
  const isGroup = condition.type === "group";
  const isUnknown = !isGroup && !fieldSet;

  const Element =
    viewSource || isUnknown
      ? ConDebug
      : condition.type === "group"
      ? ConditionsGroup
      : ConditionsFieldSet;

  const newPath = path ? [...path] : [];
  if (idx >= 0) {
    newPath.push(idx);
  }

  return (
    <div
      className={classNames(
        "relative",
        newPath.length > 0 && "m-2",
        !isGroup && (editing ? "p-2" : "p-3"),
        !isGroup && "rounded bg-default border border-primary",
        mightDelete && "bg-lightRed/10 border border-lightRed"
      )}
    >
      {editing && (
        <div className="absolute top-2 right-2 flex flex-row-reverse gap-1">
          {newPath.length > 0 && (
            <MiniButton
              color="danger"
              onClick={(e) => {
                e.preventDefault();
                setMightDelete(true);
                setTimeout(() => {
                  if (
                    window.confirm(
                      `Are you sure you want to delete ${
                        isGroup
                          ? "this group"
                          : definition?.title ?? "Unknown Condition"
                      }?`
                    )
                  ) {
                    update(
                      {
                        action: "remove",
                      },
                      newPath
                    );
                  }
                  setMightDelete(false);
                });
                return false;
              }}
            >
              Delete
            </MiniButton>
          )}
          {!isUnknown && (
            <MiniButton
              color="primary"
              onClick={(e) => {
                e.preventDefault();
                setViewSource(!viewSource);
              }}
            >
              {viewSource ? "Hide" : "View"} Source
            </MiniButton>
          )}
        </div>
      )}
      {isUnknown ? (
        <div className="text-xs text-textGray">
          <p>Unknown/invalid condition</p>
          <Element condition={condition} />
        </div>
      ) : (
        <Element
          data={data}
          fieldSet={fieldSet}
          definition={definition}
          condition={condition}
          update={update}
          path={newPath}
          idx={idx}
          errors={errors}
          defaultSuggestion={defaultSuggestion}
          editing={editing}
        />
      )}
    </div>
  );
}

function ConDebug({ condition }) {
  return (
    <pre className="font-mono mr-12 whitespace-pre-wrap">
      {JSON.stringify(condition, null, 2)}
    </pre>
  );
}
